<template><!-- svgo-optimised -->
<svg class="icon icon__pause" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M7 18.417V5h1.917v13.417zM14.667 18.417V5h1.916v13.417z"/></svg>
</template>